export const getConnectedUpdaters = (groupId, groups) => { var _a, _b; return (_b = (_a = groups[groupId]) === null || _a === void 0 ? void 0 : _a.connectedCharts) !== null && _b !== void 0 ? _b : []; };
export const executeConnectedUpdaters = (connectedCharts = [], trendCursors = [], action) => {
    if (!action)
        return;
    connectedCharts.forEach((updater) => updater(trendCursors, action));
};
